import { Controller } from "stimulus"
import ReactRailsUJS from "react_ujs"

// Re-mounts react_ujs components + MDL widgets when a turbo-frame swaps this region in, and tears
// them down on swap-out (both are Turbo-blind). MDL's downgradeElements() doesn't recurse like
// upgradeElements(), so teardown passes the already-upgraded descendants explicitly.
export default class extends Controller {
  connect() {
    ReactRailsUJS.mountComponents(this.element)
    componentHandler.upgradeElements(this.element)
  }

  disconnect() {
    ReactRailsUJS.unmountComponents(this.element)
    componentHandler.downgradeElements(this.element.querySelectorAll("[data-upgraded]"))
  }
}
